import React from "react";
import { convertToReadable } from "@sscs/utils";
import styles from "./groupUsageStatus.module.scss";

type UsageStatusProps = {
  percent?: number;
  total?: number;
  used: number;
};

const GroupUsageStatus = ({
  percent,
  total,
  used,
}: UsageStatusProps): React.JSX.Element => {
  if (percent && total)
    return (
      <>
        <div>
          {percent} % ({convertToReadable((percent * total) / 100)})
        </div>
        <div className={styles.used}>{convertToReadable(used)} used</div>
      </>
    );
  else return <>{convertToReadable(used)} used</>;
};

export default GroupUsageStatus;
